import { PRICING_MODEL_OPTIONS } from '@sequencehq/utils'
import type { IsSubOperator } from './ProductPropertyEditor.helpers'

type SubOperatorOption = { label: string; value: IsSubOperator }

export const IS_OPERATOR_OPTION: SubOperatorOption = {
  label: 'Is',
  value: 'IS'
}

export const IS_NOT_OPERATOR_OPTION: SubOperatorOption = {
  label: 'Is not',
  value: 'IS_NOT'
}

export const BOOLEAN_SUB_OPERATOR_OPTIONS: SubOperatorOption[] = [
  IS_OPERATOR_OPTION,
  IS_NOT_OPERATOR_OPTION
]

/**
 * BILLING_TYPE offers "is" on its own — the ADR settled on one comparison for a
 * field with only two values. The dropdown is still rendered so the row reads
 * like the other price-attribute rows, and adding "is not" later is a change
 * here rather than in the editor.
 *
 * ADR: https://app.notion.com/p/sequencehq/Incident-io-further-approval-conditions-3e29b9b6e5c680a78cd5f769dc0a064d
 */
export const IS_ONLY_SUB_OPERATOR_OPTIONS: SubOperatorOption[] = [
  IS_OPERATOR_OPTION
]

/**
 * The pricing editor's own model options, so a model added there shows up in
 * the condition too. Its one-line descriptions are dropped — a select option
 * has nowhere to render them, and the condition row is a plain list.
 */
export const PRICING_MODEL_SELECT_OPTIONS = PRICING_MODEL_OPTIONS.map(
  ({ value, label }) => ({ value, label })
)
